import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Pill from '../Pill/Pill';
import { getPendingBookingUrgency } from '../../shared/pendingBookingUrgency';

type Props = {
  date: string;
  time: string;
  timeZone?: string;
};

const PendingBookingUrgencyPill: React.FC<Props> = ({ date, time, timeZone }) => {
  const { t } = useTranslation();
  const storeTimeZone = useSelector((state: { settings?: { value?: { timezone?: string } } }) =>
    state.settings?.value?.timezone
  );

  const urgency = useMemo(
    () => getPendingBookingUrgency(date, time, timeZone ?? storeTimeZone),
    [date, time, timeZone, storeTimeZone]
  );

  if (!urgency) {
    return null;
  }

  if (urgency === 'due') {
    return <Pill color="red" text={t('booking.pending.urgency.due') || 'Due'} />;
  }

  return <Pill color="yellow" text={t('booking.pending.urgency.soon') || 'Soon'} />;
};

export default PendingBookingUrgencyPill;
